import React from "react";

export const NotAuthenticated = () => <span>Not authenticated</span>;
